import logoPD from '../../assets/policeLogo.png';
import { useEffect, useState } from 'react';
import { useData } from './MemberData';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router';

function HeaderBar({ currentPage }: any) {
    const navigate = useNavigate();
    const { policeMembersData, penitenciarMembersData, academieMembersData } = useData();
    const [userName, setUserName] = useState<string | null>(null);

    useEffect(() => {
        let myDiscordID = Cookies.get('myDiscordID') || '';
        const email = Cookies.get('email');
        const allPoliceTable = [...policeMembersData, ...penitenciarMembersData, ...academieMembersData];

        if (myDiscordID === '' && email) {
            for (const element of allPoliceTable) {
                if (element.email === email) {
                    Cookies.set("myDiscordID", element.discordID);
                    myDiscordID = element.discordID;
                    break;
                }
            }
        }

        for (const element of allPoliceTable) {
            if (element.discordID === myDiscordID) {
                let formattedName = '';
                if (["AGENT-PAZA", "AGENT-PAZA-SEF", "DIRECTOR-PENITENCIAR"].includes(element.grade)) {
                    formattedName = `[P-${String(element.callsign).padStart(2, '0')}] ${element.full_name}`;
                } else if (element.grade === "ACADEMIE") {
                    formattedName = `[AC] ${element.full_name}`;
                } else {
                    formattedName = `[${String(element.callsign).padStart(3, '0')}] ${element.full_name}`;
                }
                setUserName(formattedName);
                break;
            }
        }
    }, [policeMembersData, penitenciarMembersData, academieMembersData]);

    return (
        <div className="w-full h-[11%] flex items-center justify-between">
            <span className="textBold text-[#ffffff] text-[1.5vw]">Panel Poliție / {currentPage}</span>
            <div className="w-[20%] h-full flex items-center justify-end gap-[2%] pr-[1%]">
                <span className="text-wrap text-right textMedium text-[#ffffff] text-[0.8vw]">
                    {userName ?? "Redirecting..."}
                </span>
                <img className="w-[20%]" src={logoPD} alt="Logo" />
            </div>
        </div>
    );
}

export default HeaderBar;
